var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconNoPaymentRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.720417 3.05833L1.88417 4.21417C1.72583 4.42 1.615 4.68125 1.59125 4.96625V5.10083L1.58333 6.9375H4.6075L6.19083 8.52083H1.58333V13.6429C1.58333 14.2762 2.0425 14.7829 2.62833 14.8463L2.74708 14.8542H12.5242L14.1075 16.4375H2.6125C1.22708 16.4375 0.0870833 15.2738 0 13.8092V4.98208C0 4.23792 0.277083 3.55708 0.720417 3.05042V3.05833ZM16.3875 2.1875C17.7729 2.1875 18.9129 3.35125 19 4.81583V13.6429C19 14.3871 18.7229 15.0679 18.2796 15.5746L17.1396 14.4267C17.29 14.2446 17.385 14.015 17.4088 13.7696L17.4167 13.6429V8.52083H11.2258L9.6425 6.9375H17.4167V5.10083C17.4167 4.41208 16.9575 3.84208 16.3717 3.77875L16.2529 3.77083H6.47583L4.8925 2.1875H16.3875ZM15.0892 11.6875C15.5008 11.6875 15.8333 12.0437 15.8333 12.4792C15.8333 12.6613 15.7779 12.8354 15.675 12.97L14.3925 11.6875H15.0892Z",
    fill: "#DF795F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1875 1L17.8125 17.625",
    stroke: "#DF795F",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoPaymentRed);
export default __webpack_public_path__ + "static/media/icon-no-payment-red.60415f36b4c317471084658a389f0ddc.svg";
export { ForwardRef as ReactComponent };